import DashboardLayout from "../components/DashboardLayout";
import ProjectCard from "../components/ProjectCard";

const fakeProjects = [
  {
    id: 1,
    title: "Elvara Heights",
    location: "Mumbai",
    status: "Ongoing",
  },
  {
    id: 2,
    title: "Elvara Signature Villas",
    location: "Pune",
    status: "Completed",
  },
  {
    id: 3,
    title: "Elvara Business Bay",
    location: "Navi Mumbai",
    status: "Upcoming",
  },
];

export default function Projects() {
  return (
    <DashboardLayout>
      <h1>Projects</h1>

      <div style={{ display: "grid", gap: "16px" }}>
        {fakeProjects.map((project) => (
          <ProjectCard key={project.id} project={project} />
        ))}
      </div>
    </DashboardLayout>
  );
}
